import { urlIcone3d } from '../utils/iconesVeiculos'
import React, { useEffect, useState } from "react"
import axios from "axios"
import BotaoExportar from "../components/BotaoExportar"
import SeletorIconeAtivo from "../components/SeletorIconeAtivo"
import { vencimentoLicenciamento, diasAte, dataBR, UFS, textoSugestao } from "../utils/licenciamento"

const API = process.env.REACT_APP_API_URL || "http://localhost:3001/api"

export default function Ativos() {
  const [ativos, setAtivos]       = useState<any[]>([])
  const [clientes, setClientes]   = useState<any[]>([])
  const [tipos, setTipos]           = useState<any[]>([])
  const [grupos, setGrupos]         = useState<any[]>([])
  const [rastreadores, setRastreadores] = useState<any[]>([])
  const [planos, setPlanos] = useState<any[]>([])
  const [tiposCombustivel, setTiposCombustivel] = useState<any[]>([])
  const [marcasCatalogo, setMarcasCatalogo] = useState<any[]>([])
  const [modelosCatalogo, setModelosCatalogo] = useState<any[]>([])
  const [ativoRastreadores, setAtivoRastreadores] = useState<any[]>([])
  const [ativoContratos, setAtivoContratos]   = useState<any[]>([])
  const [contratos, setContratos]             = useState<any[]>([])
  const [modalDesinstalar, setModalDesinstalar] = useState(false)
  const [ativoDesinstalar, setAtivoDesinstalar] = useState<any>(null)
  const [ativoRastreadoresDesinst, setAtivoRastreadoresDesinst] = useState<any[]>([])
  const [formDesinstalar, setFormDesinstalar]   = useState<any>({data_desinstalacao:"",motivo:"",custo_desinstalacao:"",observacoes:"",rastreadores_selecionados:[]})
  const [loading, setLoading]     = useState(true)
  const [modalAlertas, setModalAlertas] = useState<any>(null)
  const [alertasAtivo, setAlertasAtivo] = useState<any[]>([])
  const [emailAlerta, setEmailAlerta]   = useState("")
  const [pagina, setPagina]       = useState(1)
  const [abaAtiva, setAbaAtiva]   = useState<"instalado"|"desinstalado">("instalado")
  const [busca, setBusca]         = useState("")
  const [filtroCliente, setFiltroCliente] = useState("")
  const [filtroStatus, setFiltroStatus]   = useState("")
  const [modal, setModal]         = useState(false)
  const [seletorIconeAberto, setSeletorIconeAberto] = useState(false)
  const [editando, setEditando]   = useState<any>(null)
  const [modalKm, setModalKm]     = useState<any>(null)
  const [novoKm, setNovoKm]       = useState("")
  const [consultandoPlaca, setConsultandoPlaca] = useState(false)
  const [erros, setErros] = useState<Record<string,boolean>>({})
  const POR_PAGINA = 15

  const [form, setForm] = useState<any>({
    nome:"", placa:"", modelo_veiculo:"", marca:"", tipo_id:"", grupo_id:"", icon_id:null, icon_color:null,
    ano_fabricacao:"", cor:"", chassis:"", renavam:"",
    hodometro_atual:"0", observacoes:"", cliente_id:"", rastreador_id:"",
    venc_ipva_licenciamento:"", mes_venc_ipva_licenciamento:"", dia_venc_licenciamento:"", uf_placa:"", venc_seguro:"", venc_revisao:"", venc_tacografo:"", alerta_docs_opcoes:["30"],
    data_ativacao:"", plano_id:""
  })
  useEffect(() => {
    if (!form.tipo_id) { setMarcasCatalogo([]); return }
    axios.get(`${API}/marcas`, { params: { tipo_id: form.tipo_id } }).then(r => setMarcasCatalogo(r.data)).catch(() => {})
  }, [form.tipo_id])
  useEffect(() => {
    if (!form.marca_id) { setModelosCatalogo([]); return }
    axios.get(`${API}/modelos`, { params: { marca_id: form.marca_id } }).then(r => setModelosCatalogo(r.data)).catch(() => {})
  }, [form.marca_id])

  // Campos obrigatórios do cadastro de ativo, usados na validação visual do formulário
  const CAMPOS_OBRIGATORIOS: {chave:string,label:string}[] = [
    {chave:"nome", label:"Nome do Ativo"},
    {chave:"tipo_id", label:"Categoria"},
    {chave:"placa", label:"Placa"},
    {chave:"cliente_id", label:"Cliente"},
    {chave:"data_ativacao", label:"Data de Ativação"},
    {chave:"plano_id", label:"Plano"},
  ]

  const validarFormulario = (): string[] => {
    const faltando: string[] = []
    const novosErros: Record<string,boolean> = {}
    for (const campo of CAMPOS_OBRIGATORIOS) {
      const valor = form[campo.chave]
      if (!valor || String(valor).trim() === "") {
        faltando.push(campo.label)
        novosErros[campo.chave] = true
      }
    }
    setErros(novosErros)
    return faltando
  }

  const estiloErro = (campo: string) => erros[campo]
    ? {border:"1px solid #dc2626", boxShadow:"0 0 0 1px #dc2626"}
    : undefined

  useEffect(() => {
    carregar()
    axios.get(`${API}/clientes`).then(r=>setClientes(r.data)).catch(()=>{})
    axios.get(`${API}/rastreadores`).then(r=>setRastreadores(r.data)).catch(()=>{})
    axios.get(`${API}/planos`).then(r=>setPlanos(r.data)).catch(()=>{})
    axios.get(`${API}/tipos-combustivel`).then(r=>setTiposCombustivel(r.data)).catch(()=>{})
    axios.get(`${API}/contratos`).then(r=>setContratos(r.data)).catch(()=>{})
    axios.get(`${API}/tipo-ativo`).then(r=>setTipos(r.data)).catch(()=>{})
    axios.get(`${API}/grupos`).then(r=>setGrupos(r.data)).catch(()=>{})
  }, [])

  const consultarPlaca = async (placa: string) => {
    if (placa.length < 7) return
    setConsultandoPlaca(true)
    try {
      const r = await axios.get(`${API}/consulta-placa/${placa.replace(/[^a-zA-Z0-9]/g,"")}`)
      if (r.data && r.data.marca) {
        setForm((f:any) => ({
          ...f,
          marca: r.data.marca||f.marca,
          modelo_veiculo: r.data.modelo||f.modelo_veiculo,
          ano_fabricacao: r.data.ano||f.ano_fabricacao,
          cor: r.data.cor||f.cor,
          chassis: r.data.chassi||f.chassis,
        }))
        alert(`✅ Veículo encontrado: ${r.data.marca} ${r.data.modelo} ${r.data.ano}`)
      }
    } catch { } finally { setConsultandoPlaca(false) }
  }

  const carregar = async () => {
    setLoading(true)
    try {
      const r = await axios.get(`${API}/ativos`)
      setAtivos(r.data)
    } catch {} finally { setLoading(false) }
  }

  const abrirAlertas = async (ativo:any) => {
    setModalAlertas(ativo)
    try {
      const r = await axios.get(`${API}/alertas-ativo/${ativo.id}`)
      setAlertasAtivo(r.data)
    } catch { setAlertasAtivo([]) }
  }

  const toggleAlerta = async (ativo:any, tipo:string) => {
    const existente = alertasAtivo.find(a=>a.tipo===tipo)
    try {
      if (existente) {
        await axios.put(`${API}/alertas-ativo/${existente.id}`, {...existente, ativo:!existente.ativo})
      } else {
        await axios.post(`${API}/alertas-ativo`, {
          ativo_id:ativo.id, cliente_id:ativo.cliente_id, tipo,
          emails:emailAlerta?[emailAlerta]:[]
        })
      }
      const r = await axios.get(`${API}/alertas-ativo/${ativo.id}`)
      setAlertasAtivo(r.data)
    } catch(e:any) { alert(e.response?.data?.erro||"Erro") }
  }

  const abrirNovo = () => {
    setEditando(null)
    setAtivoRastreadores([])
    setAtivoContratos([])
    setErros({})
    setForm({nome:"",placa:"",modelo_veiculo:"",marca:"",tipo_id:"",grupo_id:"",ano_fabricacao:"",cor:"",chassis:"",renavam:"",hodometro_atual:"0",observacoes:"",cliente_id:"",rastreador_id:"",
      venc_ipva_licenciamento:"",mes_venc_ipva_licenciamento:"",dia_venc_licenciamento:"",uf_placa:"",venc_seguro:"",venc_revisao:"",venc_tacografo:"",alerta_docs_opcoes:["30"],
      data_ativacao:"",plano_id:"",icon_id:null,icon_color:null,marca_id:null,modelo_id:null,combustivel_id:null})
    setModal(true)
  }

  const abrirEditar = async (a:any) => {
    setEditando(a)
    setErros({})
    // Carregar rastreadores vinculados
    try {
      const r = await axios.get(`${API}/ativos/${a.id}/rastreadores`)
      setAtivoRastreadores(r.data)
    } catch { setAtivoRastreadores([]) }
    // Carregar contratos vinculados
    try {
      const r = await axios.get(`${API}/ativos/${a.id}/contratos`)
      setAtivoContratos(r.data)
    } catch { setAtivoContratos([]) }
    setForm({nome:a.nome||"",placa:a.placa||"",modelo_veiculo:a.modelo_veiculo||"",marca:a.marca||"",tipo_id:a.tipo_id||"",grupo_id:a.grupo_id||"",icon_id:a.icon_id||null,icon_color:a.icon_color||null,
      ano_fabricacao:a.ano_fabricacao||"",cor:a.cor||"",chassis:a.chassis||"",renavam:a.renavam||"",
      hodometro_atual:a.hodometro_atual||"0",observacoes:a.observacoes||"",cliente_id:a.cliente_id||"",rastreador_id:a.rastreador_id||"",
      venc_ipva_licenciamento:a.venc_ipva_licenciamento?a.venc_ipva_licenciamento.split("T")[0]:"",
      mes_venc_ipva_licenciamento:a.mes_venc_ipva_licenciamento?String(a.mes_venc_ipva_licenciamento):"",
      dia_venc_licenciamento:a.dia_venc_licenciamento?String(a.dia_venc_licenciamento):"", uf_placa:a.uf_placa||"",
      venc_seguro:a.venc_seguro?a.venc_seguro.split("T")[0]:"",
      venc_revisao:a.venc_revisao?a.venc_revisao.split("T")[0]:"",
      venc_tacografo:a.venc_tacografo?a.venc_tacografo.split("T")[0]:"",
      alerta_docs_opcoes:a.alerta_docs_opcoes?a.alerta_docs_opcoes.split(","):["30"],
      data_ativacao:a.data_ativacao?a.data_ativacao.split("T")[0]:"",
      plano_id:a.plano_id||"",marca_id:a.marca_id||null,modelo_id:a.modelo_id||null,combustivel_id:a.combustivel_id||null})
    setModal(true)
  }

  const desinstalar = async () => {
    if (!formDesinstalar.data_desinstalacao) return alert("Informe a data de desinstalação")
    const sels = formDesinstalar.rastreadores_selecionados||[]
    try {
      const custosTotal = sels.reduce((s:number,r:any)=>s+parseFloat(r.custo||0),0)
      // Verificar se todos foram desinstalados
      const todosDesinst = ativoRastreadoresDesinst.length > 0 && sels.length >= ativoRastreadoresDesinst.length
      await axios.put(`${API}/ativos/${ativoDesinstalar.id}`, {
        nome: ativoDesinstalar.nome,
        status_instalacao: todosDesinst ? "desinstalado" : "parcial",
        data_desinstalacao: formDesinstalar.data_desinstalacao,
        motivo_desinstalacao: formDesinstalar.motivo,
        custo_desinstalacao: custosTotal
      })
      // Registrar histórico por rastreador
      if (sels.length > 0) {
        for (const r of sels) {
          await axios.post(`${API}/historico-instalacoes`, {
            ativo_id: ativoDesinstalar.id,
            rastreador_id: r.id,
            tipo: "desinstalacao",
            data_evento: formDesinstalar.data_desinstalacao,
            custo: r.custo||0,
            observacoes: formDesinstalar.observacoes
          }).catch(()=>{})
        }
      } else {
        await axios.post(`${API}/historico-instalacoes`, {
          ativo_id: ativoDesinstalar.id,
          tipo: "desinstalacao",
          data_evento: formDesinstalar.data_desinstalacao,
          custo: custosTotal,
          observacoes: formDesinstalar.observacoes
        }).catch(()=>{})
      }
      setModalDesinstalar(false)
      carregar()
    } catch(e:any) { alert(e.response?.data?.erro||"Erro ao desinstalar") }
  }

  const [sugestaoMsg, setSugestaoMsg] = useState("")
  // consulta o calendario do estado (UF + final da placa) e preenche o mes e o dia do vencimento real
  const sugerirVencimento = async (ufEscolhida?: string, soSeVazio = false) => {
    const uf = ufEscolhida ?? form.uf_placa
    if (!uf || !form.placa) { setSugestaoMsg("Informe a placa e a UF da placa para consultar o calendário."); return }
    if (soSeVazio && (form.mes_venc_ipva_licenciamento || form.dia_venc_licenciamento)) return
    try {
      const r = await axios.get(`${API}/licenciamento/sugestao`, { params: { uf, placa: form.placa } })
      setSugestaoMsg(textoSugestao(uf, r.data))
      if (r.data.encontrado) setForm((f:any) => ({ ...f, mes_venc_ipva_licenciamento: String(r.data.mes), dia_venc_licenciamento: String(r.data.dia) }))
    } catch { setSugestaoMsg("Não foi possível consultar o calendário agora. Digite o mês e o dia do vencimento.") }
  }

  const salvar = async () => {
    const faltando = validarFormulario()
    if (faltando.length > 0) {
      alert(`⚠️ Preencha os campos obrigatórios:\n\n• ${faltando.join("\n• ")}`)
      return
    }
    try {
      let id = editando?.id
      if (editando) {
        await axios.put(`${API}/ativos/${editando.id}`, form)
      } else {
        const r = await axios.post(`${API}/ativos`, form)
        id = r.data.id
        // o cadastro novo nao grava os documentos: grava logo em seguida (so estes campos)
        const docs:any = { uf_placa:form.uf_placa, mes_venc_ipva_licenciamento:form.mes_venc_ipva_licenciamento, dia_venc_licenciamento:form.dia_venc_licenciamento, venc_ipva_licenciamento:form.venc_ipva_licenciamento, venc_seguro:form.venc_seguro, venc_revisao:form.venc_revisao, venc_tacografo:form.venc_tacografo, alerta_docs_opcoes:form.alerta_docs_opcoes }
        if (Object.values(docs).some((v:any)=>v && !(Array.isArray(v) && v.join()==="30"))) await axios.put(`${API}/ativos/${id}`, docs)
      }
      // Salvar rastreadores vinculados
      if (id && ativoRastreadores.length > 0) {
        await axios.post(`${API}/ativos/${id}/rastreadores`, { rastreadores: ativoRastreadores })
      }
      // Salvar contratos vinculados
      if (id) {
        await axios.post(`${API}/ativos/${id}/contratos`, { contratos: ativoContratos }).catch(()=>{})
      }
      setErros({})
      setModal(false)
      await carregar()
    } catch (e:any) { alert(e.response?.data?.erro||"Erro ao salvar") }
  }

  const excluir = async (id:string) => {
    if (!window.confirm("Excluir este ativo?")) return
    try { await axios.delete(`${API}/ativos/${id}`); await carregar() } catch {}
  }

  const atualizarKm = async () => {
    if (!modalKm || novoKm==="") return
    try {
      await axios.put(`${API}/ativos/${modalKm.id}`, {hodometro_atual:parseFloat(novoKm)})
      setModalKm(null); setNovoKm(""); await carregar()
    } catch { alert("Erro ao atualizar") }
  }

  const countInstalados = ativos.filter(d=>d.status_instalacao!=="desinstalado"&&d.status_instalacao!=="parcial").length
  const countDesinstalados = ativos.filter(d=>d.status_instalacao==="desinstalado"||d.status_instalacao==="parcial").length

  const filtrados = ativos.filter(a => {
    const q = busca.toLowerCase()
    const matchBusca = !busca || a.nome?.toLowerCase().includes(q) || a.placa?.toLowerCase().includes(q) || a.modelo_veiculo?.toLowerCase().includes(q)
    const matchCliente = !filtroCliente || a.cliente_id === filtroCliente
    const matchStatus = !filtroStatus || (filtroStatus==="ativo" ? a.ativo : !a.ativo)
    return matchBusca && matchCliente && matchStatus
  })

  const totalPaginas = Math.ceil(filtrados.length / POR_PAGINA)
  const paginados = filtrados.slice((pagina-1)*POR_PAGINA, pagina*POR_PAGINA)

  const fmtKm = (n:any) => n && parseFloat(n)>0 ? `${Math.round(parseFloat(n)).toLocaleString("pt-BR")} km` : "—"

  return (
    <div style={{padding:24,overflowY:"auto",height:"100%"}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16}}>
        <div>
          <h2 style={{fontSize:20,fontWeight:700}}>🚗 Ativos</h2>
          <p style={{fontSize:13,color:"#64748b"}}>{filtrados.length} de {ativos.length} registro(s)</p>
        </div>
        <div style={{display:'flex',gap:8}}>
          <BotaoExportar endpoint="ativos" titulo="Ativos" filtros={{busca,cliente_id:filtroCliente,status:filtroStatus}} />
          <button className="btn btn-primary" onClick={abrirNovo}>+ Novo ativo</button>
        </div>
      </div>

      {/* Abas Instalado/Desinstalado */}
      <div style={{display:"flex",gap:0,marginBottom:16,borderBottom:"1px solid #2d4166"}}>
        {([
          ["instalado","🟢 Instalados"],
          ["desinstalado","🔴 Desinstalados"]
        ] as const).map(([id,label])=>{
          const count = id==="instalado" ? countInstalados : countDesinstalados
          return (
            <button key={id} onClick={()=>{setAbaAtiva(id);setPagina(1)}}
              style={{padding:"8px 20px",border:"none",background:"transparent",cursor:"pointer",
                fontFamily:"Inter",fontSize:13,fontWeight:abaAtiva===id?700:400,
                color:abaAtiva===id?(id==="instalado"?"#22c55e":"#f87171"):"#64748b",
                borderBottom:abaAtiva===id?`2px solid ${id==="instalado"?"#22c55e":"#f87171"}`:"2px solid transparent",
                marginBottom:-1}}>
              {label} <span style={{fontSize:11,color:"#475569",marginLeft:4}}>({count})</span>
            </button>
          )
        })}
      </div>

      {/* Filtros */}
      <div style={{background:"#1e2f4a",border:"1px solid #2d4166",borderRadius:10,padding:"12px 16px",marginBottom:16,display:"flex",gap:10,flexWrap:"wrap",alignItems:"center"}}>
        <input placeholder="Buscar nome, placa, modelo..." value={busca}
          onChange={e=>{setBusca(e.target.value);setPagina(1)}}
          style={{flex:2,minWidth:180}} />
        <select value={filtroCliente} onChange={e=>{setFiltroCliente(e.target.value);setPagina(1)}} style={{flex:1,minWidth:160}}>
          <option value="">Todos os clientes</option>
          {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
        </select>
        <select value={filtroStatus} onChange={e=>{setFiltroStatus(e.target.value);setPagina(1)}} style={{flex:1,minWidth:120}}>
          <option value="">Todos</option>
          <option value="ativo">Ativos</option>
          <option value="inativo">Inativos</option>
        </select>
        {(busca||filtroCliente||filtroStatus) && (
          <button className="btn btn-ghost" style={{fontSize:12}} onClick={()=>{setBusca("");setFiltroCliente("");setFiltroStatus("");setPagina(1)}}>
            ✕ Limpar
          </button>
        )}
      </div>

      {/* Tabela */}
      <div style={{background:"#1e2f4a",border:"1px solid #2d4166",borderRadius:10,overflow:"hidden"}}>
        <table style={{width:"100%",borderCollapse:"collapse"}}>
          <thead>
            <tr style={{borderBottom:"1px solid #2d4166",background:"#162035"}}>
              {["Nome","Placa","Marca / Modelo","Cliente","Hodômetro","Status GPS","Hodômetro","Ações"].map(h=>(
                <th key={h} style={{padding:"10px 12px",textAlign:"left",fontSize:11,fontWeight:600,color:"#64748b",whiteSpace:"nowrap"}}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={8} style={{textAlign:"center",padding:40,color:"#64748b"}}>Carregando...</td></tr>
            ) : paginados.length === 0 ? (
              <tr><td colSpan={8} style={{textAlign:"center",padding:40,color:"#64748b"}}>
                Nenhum ativo encontrado
              </td></tr>
            ) : paginados.map((a:any,i:number)=>(
              <tr key={a.id} style={{borderBottom:"1px solid #2d416644",background:i%2===0?"transparent":"#162035",transition:"background 0.1s"}}
                onMouseEnter={e=>(e.currentTarget as HTMLTableRowElement).style.background="#0c2a4a"}
                onMouseLeave={e=>(e.currentTarget as HTMLTableRowElement).style.background=i%2===0?"transparent":"#162035"}>
                <td style={{padding:"10px 12px",fontSize:13,fontWeight:500,color:"#f1f5f9"}}>{a.nome}</td>
                <td style={{padding:"10px 12px",fontSize:12}}>
                  {a.placa ? <span style={{background:"#0c2a4a",border:"1px solid #2d4166",borderRadius:4,padding:"2px 6px",fontFamily:"monospace",fontSize:12}}>{a.placa}</span> : <span style={{color:"#475569"}}>—</span>}
                </td>
                <td style={{padding:"10px 12px",fontSize:12,color:"#94a3b8"}}>
                  {a.marca||a.modelo_veiculo ? `${a.marca||""}${a.marca&&a.modelo_veiculo?" / ":""}${a.modelo_veiculo||""}` : <span style={{color:"#475569"}}>—</span>}
                </td>
                <td style={{padding:"10px 12px",fontSize:12,color:"#94a3b8"}}>{a.cliente_nome||<span style={{color:"#475569"}}>—</span>}</td>
                <td style={{padding:"10px 12px",fontSize:12}}>
                  <span style={{color:a.ignicao?"#22c55e":"#64748b",fontWeight:600}}>
                    {a.ignicao?"● Ligado":"● Desl."}
                  </span>
                  {a.velocidade>0&&<span style={{color:"#0ea5e9",marginLeft:4,fontSize:11}}>{Math.round(a.velocidade)}km/h</span>}
                </td>
                <td style={{padding:"10px 12px",fontSize:12,color:"#0ea5e9"}}>{fmtKm(a.hodometro_atual)}</td>
                <td style={{padding:"10px 12px"}}>
                  <span className={`badge badge-${a.ativo?"verde":"cinza"}`} style={{fontSize:10}}>{a.ativo?"Ativo":"Inativo"}</span>
                </td>
                <td style={{padding:"10px 12px"}}>
                  <div style={{display:"flex",gap:4}}>
                    <button title="Editar" onClick={()=>abrirEditar(a)}
                      style={{background:"#0c2a4a",border:"1px solid #2d4166",borderRadius:6,color:"#38bdf8",padding:"4px 8px",cursor:"pointer",fontSize:12}}>✏️</button>
                    <button title="Atualizar hodômetro" onClick={()=>{setModalKm(a);setNovoKm(a.hodometro_atual||"0")}}
                      style={{background:"#0c2a4a",border:"1px solid #2d4166",borderRadius:6,color:"#f59e0b",padding:"4px 8px",cursor:"pointer",fontSize:12}}>📏</button>
                    {a.status_instalacao !== "desinstalado" ? (
                      <button title="Desinstalar" onClick={()=>{
                        setAtivoDesinstalar(a)
                        setFormDesinstalar({data_desinstalacao:new Date().toISOString().split("T")[0],motivo:"",custo_desinstalacao:"",observacoes:"",rastreadores_selecionados:[]})
                        // Carregar rastreadores e custo do plano
                        axios.get(`${API}/ativos/${a.id}/rastreadores`).then(async(r)=>{
                          setAtivoRastreadoresDesinst(r.data)
                          // Buscar custo de desinstalação do plano
                          if (a.plano_id) {
                            try {
                              const planos = await axios.get(`${API}/planos`)
                              const plano = planos.data.find((p:any)=>p.id===a.plano_id)
                              if (plano && plano.custo_desinstalacao) {
                                const custoPorRastr = plano.custo_desinstalacao
                                setFormDesinstalar((f:any)=>({...f,
                                  custo_por_rastreador: custoPorRastr,
                                  rastreadores_selecionados: r.data.map((rs:any)=>({
                                    id: rs.rastreador_id||rs.id,
                                    nome: rs.nome||rs.imei,
                                    imei: rs.imei,
                                    custo: custoPorRastr
                                  }))
                                }))
                              }
                            } catch {}
                          }
                        }).catch(()=>setAtivoRastreadoresDesinst([]))
                        setModalDesinstalar(true)
                      }} style={{background:"#451a03",border:"1px solid #f59e0b",borderRadius:6,color:"#fbbf24",padding:"4px 8px",cursor:"pointer",fontSize:12}}>🔧</button>
                    ) : (
                      <span title="Desinstalado" style={{background:"#450a0a",border:"1px solid #dc2626",borderRadius:6,color:"#f87171",padding:"4px 8px",fontSize:12}}>🔴</span>
                    )}
                    <button title="Excluir" onClick={()=>excluir(a.id)}
                      style={{background:"#450a0a",border:"1px solid #dc2626",borderRadius:6,color:"#f87171",padding:"4px 8px",cursor:"pointer",fontSize:12}}>🗑</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Paginação */}
      {totalPaginas > 1 && (
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",gap:8,marginTop:16}}>
          <button className="btn btn-ghost" style={{fontSize:12,padding:"4px 10px"}} onClick={()=>setPagina(p=>Math.max(1,p-1))} disabled={pagina===1}>«</button>
          {Array.from({length:totalPaginas},(_,i)=>i+1).map(p=>(
            <button key={p} onClick={()=>setPagina(p)}
              style={{padding:"4px 10px",borderRadius:6,border:"none",cursor:"pointer",fontFamily:"Inter",fontSize:12,
                background:pagina===p?"#0ea5e9":"#1e2f4a",color:pagina===p?"#fff":"#94a3b8"}}>
              {p}
            </button>
          ))}
          <button className="btn btn-ghost" style={{fontSize:12,padding:"4px 10px"}} onClick={()=>setPagina(p=>Math.min(totalPaginas,p+1))} disabled={pagina===totalPaginas}>»</button>
        </div>
      )}

      {/* Modal cadastro/edição */}
      {modal && (
        <div className="modal-overlay">
          <div className="modal" style={{width:580}}>
            <div className="modal-header" style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <h3>{editando?"✏️ Editar ativo":"🚗 Novo ativo"}</h3>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <button className="btn btn-primary" onClick={salvar}>💾 {editando?"Salvar alterações":"Cadastrar ativo"}</button>
                <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModal(false)}>✕</button>
              </div>
            </div>
            {Object.keys(erros).length > 0 && (
              <div style={{background:"#450a0a",border:"1px solid #dc2626",borderRadius:8,
                padding:"10px 14px",marginBottom:14,fontSize:12,color:"#f87171"}}>
                ⚠️ Preencha os campos obrigatórios marcados em vermelho abaixo.
              </div>
            )}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12}}>
              <div className="form-group full">
                <label>Categoria *</label>
                <select value={form.tipo_id} onChange={e=>setForm({...form,tipo_id:e.target.value,marca_id:null,modelo_id:null})}
                  style={estiloErro("tipo_id")}>
                  <option value="">— Selecione a categoria do ativo —</option>
                  {tipos.map((t:any)=><option key={t.id} value={t.id}>{t.nome}</option>)}
                </select>
                {!form.tipo_id && (
                  <div style={{fontSize:11,color:"#38bdf8",marginTop:4}}>
                    👆 Escolha a categoria pra liberar o restante do formulário
                  </div>
                )}
              </div>
              <div className="form-group full" style={{gridColumn:"1/-1",display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,
                opacity:form.tipo_id?1:0.35, pointerEvents:form.tipo_id?"auto":"none", transition:"opacity 0.2s"}}>
              <div className="form-group full">
                <label>Nome do Ativo *</label>
                <input value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}
                  placeholder="Ex: Caminhão 001" style={estiloErro("nome")} />
              </div>
              <div className="form-group full">
                <label>Ícone do ativo</label>
                <div style={{display:"flex",alignItems:"center",gap:12}}>
                  <div style={{width:48,height:48,borderRadius:8,background:"#0c2a4a",border:"1px solid #2d4166",display:"flex",alignItems:"center",justifyContent:"center"}}>
                    {form.icon_id ? (
                      <img src={form.icon_id && String(form.icon_id).startsWith('v3d_') ? urlIcone3d(form.icon_id, form.icon_color, 225) : `/vehicle-icons/${form.icon_id}.png`} alt="" width={36} height={36} style={{objectFit:"contain"}} />
                    ) : (
                      <span style={{fontSize:20,color:"#475569"}}>📍</span>
                    )}
                  </div>
                  <button type="button" onClick={()=>setSeletorIconeAberto(true)}
                    style={{padding:"8px 14px",borderRadius:8,border:"1px solid #2d4166",background:"#0c2a4a",color:"#38bdf8",cursor:"pointer",fontSize:12.5,fontWeight:600}}>
                    {form.icon_id ? "Alterar ícone" : "Escolher ícone"}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label>Grupo</label>
                <select value={form.grupo_id} onChange={e=>setForm({...form,grupo_id:e.target.value})}>
                  <option value="">— Selecione —</option>
                  {grupos.map((g:any)=><option key={g.id} value={g.id}>{g.nome}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Placa *</label>
                <div style={{display:"flex",gap:6}}>
                  <input value={form.placa}
                    onChange={e=>setForm({...form,placa:e.target.value.toUpperCase()})}
                    placeholder="ABC-1234" style={{flex:1, ...estiloErro("placa")}}
                    onBlur={e=>consultarPlaca(e.target.value)} />
                  <button type="button"
                    onClick={()=>consultarPlaca(form.placa)}
                    disabled={consultandoPlaca||form.placa.length<7}
                    style={{padding:"0 10px",borderRadius:8,border:"1px solid #2d4166",
                      background:"#0c2a4a",color:"#38bdf8",cursor:"pointer",
                      fontSize:11,whiteSpace:"nowrap",fontFamily:"Inter"}}>
                    {consultandoPlaca?"🔍...":"🔍 Consultar"}
                  </button>
                </div>
              </div>
              <div className="form-group">
                <label>Marca</label>
                <select value={form.marca_id||""} onChange={e=>setForm({...form,marca_id:e.target.value||null,modelo_id:null})}>
                  <option value="">— Selecione a marca —</option>
                  {marcasCatalogo.map((m:any)=><option key={m.id} value={m.id}>{m.nome}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Modelo</label>
                <select value={form.modelo_id||""} onChange={e=>setForm({...form,modelo_id:e.target.value||null})}
                  disabled={!form.marca_id}>
                  <option value="">{form.marca_id?"— Selecione o modelo —":"Escolha a marca primeiro"}</option>
                  {modelosCatalogo.map((mo:any)=><option key={mo.id} value={mo.id}>{mo.nome}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Ano</label>
                <input type="number" value={form.ano_fabricacao} onChange={e=>setForm({...form,ano_fabricacao:e.target.value})} placeholder="2020" />
              </div>
              <div className="form-group">
                <label>Cor</label>
                <input value={form.cor} onChange={e=>setForm({...form,cor:e.target.value})} placeholder="Branco" />
              </div>
              <div className="form-group">
                <label>Combustível</label>
                <select value={form.combustivel_id||""} onChange={e=>setForm({...form,combustivel_id:e.target.value||null})}>
                  <option value="">— Selecione —</option>
                  {tiposCombustivel.map((tc:any)=><option key={tc.id} value={tc.id}>{tc.nome}</option>)}
                </select>
              </div>
              <div className="form-group">
                <label>Chassis</label>
                <input value={form.chassis} onChange={e=>setForm({...form,chassis:e.target.value})} />
              </div>
              <div className="form-group">
                <label>RENAVAM</label>
                <input value={form.renavam} onChange={e=>setForm({...form,renavam:e.target.value})} />
              </div>
              <div className="form-group">
                <label>📏 Hodômetro atual (km)</label>
                <input type="number" value={form.hodometro_atual} onChange={e=>setForm({...form,hodometro_atual:e.target.value})} placeholder="0" min={0} />
              </div>
              <div className="form-group">
                <label>Cliente *</label>
                <select value={form.cliente_id} onChange={e=>setForm({...form,cliente_id:e.target.value})}
                  style={estiloErro("cliente_id")}>
                  <option value="">— Selecione —</option>
                  {clientes.map((c:any)=><option key={c.id} value={c.id}>{c.razao_social}</option>)}
                </select>
              </div>
              <div className="form-group full" style={{gridColumn:"1/-1",borderTop:"1px solid #2d4166",paddingTop:12,marginTop:4}}>
                <div style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:12}}>📋 Vencimento de documentos</div>
              </div>

              <div className="form-group full">
                <label>IPVA / Licenciamento</label>
                <div style={{display:"grid",gridTemplateColumns:"110px 1fr 90px",gap:8}}>
                  <div>
                    <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>UF da placa</label>
                    <select aria-label="UF da placa" value={form.uf_placa}
                      onChange={e=>{ const uf=e.target.value; setForm({...form,uf_placa:uf}); if(uf) sugerirVencimento(uf,true) }}>
                      <option value="">— UF —</option>
                      {UFS.map(u=><option key={u} value={u}>{u}</option>)}
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Mês do vencimento *</label>
                    <select aria-label="Mês do vencimento" value={form.mes_venc_ipva_licenciamento}
                      onChange={e=>setForm({...form,mes_venc_ipva_licenciamento:e.target.value})}>
                      <option value="">— Selecione o mês —</option>
                      {["Janeiro","Fevereiro","Março","Abril","Maio","Junho",
                        "Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"].map((m,i)=>(
                        <option key={i+1} value={String(i+1)}>{i+1} - {m}</option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Dia</label>
                    <input type="number" min={1} max={31} aria-label="Dia do vencimento" value={form.dia_venc_licenciamento}
                      onChange={e=>setForm({...form,dia_venc_licenciamento:e.target.value})} placeholder="1-31" />
                  </div>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:10,marginTop:6,flexWrap:"wrap"}}>
                  <button type="button" className="btn btn-ghost" style={{padding:"4px 10px",fontSize:11}} onClick={()=>sugerirVencimento()}>📅 Sugerir pelo calendário do estado</button>
                  <span style={{fontSize:10,color:"#475569"}}>{sugestaoMsg || "Vencimento real = dia e mês limite da placa (varia por estado e final da placa)."}</span>
                </div>
                <div style={{marginTop:8}}>
                  <label style={{fontSize:11,color:"#64748b",display:"block",marginBottom:4}}>Data do último pagamento</label>
                  <input type="date" aria-label="Data do último pagamento" value={form.venc_ipva_licenciamento}
                    onChange={e=>setForm({...form,venc_ipva_licenciamento:e.target.value})} />
                  <div style={{fontSize:10,color:"#475569",marginTop:3}}>Pode ser antes ou depois do vencimento. O próximo vencimento é o mesmo dia no ano seguinte ao ciclo pago.</div>
                </div>
                {(form.venc_ipva_licenciamento || form.mes_venc_ipva_licenciamento) && (() => {
                  // vencimento = data do ultimo pagamento + 1 ano (ou o mes cadastrado, se nao houver data) — utils/licenciamento.ts
                  const v = vencimentoLicenciamento(form.venc_ipva_licenciamento, form.mes_venc_ipva_licenciamento, form.dia_venc_licenciamento)
                  if (!v.venc) return null
                  const dias = diasAte(v.venc)
                  const vencido = dias < 0
                  return (
                    <div style={{marginTop:8,padding:"10px 14px",borderRadius:8,display:"flex",alignItems:"center",gap:10,
                      background:vencido?"#450a0a":dias<=30?"#451a03":dias<=90?"#0c2a4a":"#0d1b2e",
                      border:`1px solid ${vencido?"#dc2626":dias<=30?"#f59e0b":dias<=90?"#f59e0b":"#0ea5e9"}`}}>
                      <span style={{fontSize:22}}>{vencido?"🚨":dias<=30?"⚠️":dias<=90?"⏰":"✅"}</span>
                      <div style={{flex:1}}>
                        <div style={{fontSize:12,fontWeight:700,
                          color:vencido?"#f87171":dias<=30?"#fbbf24":dias<=90?"#fbbf24":"#38bdf8"}}>
                          {vencido ? `VENCIDO — venceu em ${dataBR(v.venc)}` : `Próximo vencimento: ${dataBR(v.venc)}`}
                        </div>
                        <div style={{fontSize:11,color:"#64748b",marginTop:2}}>
                          {vencido ? "⚠️ Regularize o pagamento — veículo com documentação irregular" : dias===0 ? "Vence hoje!" : `Faltam ${dias} dias`}
                          {v.calculado ? (v.pagamento ? " · aproximado: informe o dia do vencimento" : " · aproximado: informe a data do último pagamento") : ""}
                        </div>
                        {v.pagamento && (
                          <div style={{fontSize:10,color:"#475569",marginTop:2}}>
                            Último pagamento: {dataBR(v.pagamento)}{v.vencReal ? ` · vencimento real todo dia ${v.vencReal.slice(8,10)}/${v.vencReal.slice(5,7)}` : ""}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                })()}
              </div>

              <div className="form-group">
                <label>Seguro</label>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <input type="date" value={form.venc_seguro}
                    onChange={e=>setForm({...form,venc_seguro:e.target.value})} style={{flex:1}} />
                  {form.venc_seguro && (() => {
                    const venc = new Date(form.venc_seguro)
                    const dias = Math.ceil((venc.getTime() - new Date().getTime()) / (1000*60*60*24))
                    return <span style={{fontSize:10,color:dias<0?"#f87171":dias<=30?"#fbbf24":"#38bdf8",whiteSpace:"nowrap"}}>
                      {dias<0?`⚠️ Vencido`:`${dias}d`}
                    </span>
                  })()}
                </div>
              </div>

              <div className="form-group">
                <label>Revisão</label>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <input type="date" value={form.venc_revisao}
                    onChange={e=>setForm({...form,venc_revisao:e.target.value})} style={{flex:1}} />
                  {form.venc_revisao && (() => {
                    const venc = new Date(form.venc_revisao)
                    const dias = Math.ceil((venc.getTime() - new Date().getTime()) / (1000*60*60*24))
                    return <span style={{fontSize:10,color:dias<0?"#f87171":dias<=30?"#fbbf24":"#38bdf8",whiteSpace:"nowrap"}}>
                      {dias<0?`⚠️ Vencido`:`${dias}d`}
                    </span>
                  })()}
                </div>
              </div>

              <div className="form-group">
                <label>Tacógrafo</label>
                <div style={{display:"flex",gap:8,alignItems:"center"}}>
                  <input type="date" value={form.venc_tacografo}
                    onChange={e=>setForm({...form,venc_tacografo:e.target.value})} style={{flex:1}} />
                  {form.venc_tacografo && (() => {
                    const venc = new Date(form.venc_tacografo)
                    const dias = Math.ceil((venc.getTime() - new Date().getTime()) / (1000*60*60*24))
                    return <span style={{fontSize:10,color:dias<0?"#f87171":dias<=30?"#fbbf24":"#38bdf8",whiteSpace:"nowrap"}}>
                      {dias<0?`⚠️ Vencido`:`${dias}d`}
                    </span>
                  })()}
                </div>
              </div>

              <div className="form-group">
                <label>⏰ Alertar com antecedência</label>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  {[15,30,60,90].map(d=>{
                    const selecionado = (form.alerta_docs_opcoes||[]).includes(String(d))
                    return (
                      <button key={d} type="button"
                        onClick={()=>{
                          const atual = form.alerta_docs_opcoes||[]
                          const novo = selecionado
                            ? atual.filter((x:string)=>x!==String(d))
                            : [...atual, String(d)]
                          setForm({...form,alerta_docs_opcoes:novo})
                        }}
                        style={{padding:"5px 12px",borderRadius:6,border:"none",cursor:"pointer",fontFamily:"Inter",fontSize:11,
                          background:selecionado?"#0ea5e9":"#1a2744",
                          color:selecionado?"#fff":"#94a3b8",
                          outline:selecionado?"2px solid #0ea5e9":"1px solid #2d4166"}}>
                        {d} dias
                      </button>
                    )
                  })}
                </div>
                {(form.alerta_docs_opcoes||[]).length > 0 && (
                  <div style={{fontSize:11,color:"#38bdf8",marginTop:4}}>
                    ✉️ Alertas em: {(form.alerta_docs_opcoes||[]).sort((a:string,b:string)=>parseInt(a)-parseInt(b)).join(", ")} dias antes do vencimento
                  </div>
                )}
              </div>
              <div className="form-group full" style={{gridColumn:"1/-1",borderTop:"1px solid #2d4166",paddingTop:12,marginTop:4}}>
                <div style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:12}}>💰 Contrato / Faturamento</div>
              </div>
              <div className="form-group">
                <label>📅 Data de ativação *</label>
                <input type="date" value={form.data_ativacao}
                  onChange={e=>setForm({...form,data_ativacao:e.target.value})}
                  style={estiloErro("data_ativacao")} />
                {form.data_ativacao && (() => {
                  const dt = new Date(form.data_ativacao)
                  const dia = dt.getUTCDate()
                  const diasMes = new Date(dt.getUTCFullYear(), dt.getUTCMonth()+1, 0).getDate()
                  const diasRestantes = diasMes - dia + 1
                  const proRata = diasRestantes < diasMes
                  return (
                    <div style={{fontSize:11,color:"#38bdf8",marginTop:4}}>
                      {proRata
                        ? `⚡ Pro rata: ${diasRestantes} dias (ativado dia ${dia})`
                        : `✅ Mês completo`}
                    </div>
                  )
                })()}
                <div style={{fontSize:10,color:"#475569",marginTop:3}}>
                  Faturamento: dia 01 ao 30 · NF-e emitida no dia 01 do mês seguinte
                </div>
              </div>
              <div className="form-group">
                <label>📋 Plano de rastreamento *</label>
                <select value={form.plano_id} onChange={e=>setForm({...form,plano_id:e.target.value})}
                  style={estiloErro("plano_id")}>
                  <option value="">— Selecione o plano —</option>
                  {planos.map((p:any)=>(
                    <option key={p.id} value={p.id}>
                      {p.nome} · R$ {parseFloat(p.valor).toFixed(2).replace(".",",")}
                    </option>
                  ))}
                </select>
                {form.plano_id && form.data_ativacao && (() => {
                  const plano = planos.find((p:any)=>p.id===form.plano_id)
                  if (!plano) return null
                  const dt = new Date(form.data_ativacao)
                  const dia = dt.getUTCDate()
                  const diasMes = new Date(dt.getUTCFullYear(), dt.getUTCMonth()+1, 0).getDate()
                  const diasRestantes = diasMes - dia + 1
                  const valorMensal = parseFloat(plano.valor)
                  const valorProRata = (valorMensal / diasMes * diasRestantes)
                  const proRata = diasRestantes < diasMes
                  return (
                    <div style={{marginTop:6,background:"#0c2a4a",border:"1px solid #0ea5e9",
                      borderRadius:8,padding:"8px 12px"}}>
                      <div style={{fontSize:11,color:"#64748b"}}>Valor mensal: <strong style={{color:"#f1f5f9"}}>R$ {valorMensal.toFixed(2).replace(".",",")}</strong></div>
                      {proRata && <div style={{fontSize:11,color:"#f59e0b",marginTop:2}}>
                        1ª fatura (pro rata {diasRestantes}d): <strong>R$ {valorProRata.toFixed(2).replace(".",",")}</strong>
                      </div>}
                    </div>
                  )
                })()}
              </div>
              <div className="form-group full" style={{gridColumn:"1/-1",borderTop:"1px solid #2d4166",paddingTop:12,marginTop:4}}>
                <div style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:12}}>📡 Rastreamento</div>
              </div>
              <div className="form-group full">
                <label>📡 Rastreadores vinculados (até 4)</label>
                <div style={{display:"flex",gap:8,marginBottom:8}}>
                  <select id="sel-rastreador" style={{flex:1}}>
                    <option value="">— Selecionar rastreador —</option>
                    {rastreadores.filter(r=>!ativoRastreadores.find((ar:any)=>ar.rastreador_id===r.id)).map((r:any)=>(
                      <option key={r.id} value={r.id}>
                        {r.nome||r.imei} · {r.imei}
                      </option>
                    ))}
                  </select>
                  <button type="button" className="btn btn-primary" style={{flexShrink:0}}
                    onClick={()=>{
                      const sel = document.getElementById("sel-rastreador") as HTMLSelectElement
                      if (!sel.value) return
                      if (ativoRastreadores.length >= 4) return alert("Máximo 4 rastreadores por ativo")
                      const rastr = rastreadores.find(r=>r.id===sel.value)
                      if (!rastr) return
                      setAtivoRastreadores([...ativoRastreadores, {
                        rastreador_id: rastr.id, imei: rastr.imei,
                        nome: rastr.nome||rastr.imei, principal: ativoRastreadores.length===0,
                        novo: true
                      }])
                      sel.value = ""
                    }}>
                    + Adicionar
                  </button>
                </div>
                {ativoRastreadores.length === 0 && (
                  <div style={{fontSize:12,color:"#475569",padding:"8px 0"}}>Nenhum rastreador vinculado</div>
                )}
                {ativoRastreadores.map((ar:any, i:number)=>(
                  <div key={ar.rastreador_id||i} style={{display:"flex",alignItems:"center",gap:8,
                    background:"#0d1b2e",borderRadius:8,padding:"8px 12px",marginBottom:6,
                    border:`1px solid ${ar.principal?"#22c55e":"#2d4166"}`}}>
                    <span style={{fontSize:18}}>📡</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,fontWeight:500}}>{ar.nome||ar.imei}</div>
                      <div style={{fontSize:10,color:"#64748b"}}>{ar.imei}</div>
                    </div>
                    {ar.principal ? (
                      <span style={{fontSize:10,background:"#14532d",border:"1px solid #22c55e",
                        borderRadius:10,padding:"2px 8px",color:"#4ade80"}}>Principal</span>
                    ) : (
                      <button type="button" onClick={()=>setAtivoRastreadores(ativoRastreadores.map((x:any,j:number)=>({...x,principal:j===i})))}
                        style={{fontSize:10,background:"none",border:"1px solid #2d4166",borderRadius:10,
                          padding:"2px 8px",color:"#64748b",cursor:"pointer"}}>
                        Tornar principal
                      </button>
                    )}
                    <button type="button" onClick={()=>setAtivoRastreadores(ativoRastreadores.filter((_:any,j:number)=>j!==i))}
                      style={{background:"#450a0a",border:"1px solid #dc2626",borderRadius:6,
                        color:"#f87171",padding:"3px 7px",cursor:"pointer",fontSize:12}}>✕</button>
                  </div>
                ))}
                <div style={{fontSize:11,color:"#475569",marginTop:4}}>
                  ℹ️ O mapa usa sempre a posição mais recente entre todos os rastreadores. Para GT06/J16 o hodômetro é manual.
                </div>
              </div>
              <div className="form-group full" style={{gridColumn:"1/-1",borderTop:"1px solid #2d4166",paddingTop:12,marginTop:4}}>
                <div style={{fontSize:13,fontWeight:700,color:"#94a3b8",marginBottom:8}}>📄 Contratos vinculados (até 4)</div>
                <div style={{marginBottom:8,fontSize:11,color:"#475569"}}>
                  Cada rastreador pode ter seu próprio contrato. Vincule aqui os contratos deste ativo.
                </div>
                {ativoContratos.length < 4 && (
                  <div style={{display:"flex",gap:8,marginBottom:8}}>
                    <select id="sel-contrato" style={{flex:1}}>
                      <option value="">— Selecionar contrato —</option>
                      {contratos.filter((co:any)=>
                        !ativoContratos.find((ac:any)=>ac.contrato_id===co.id) && co.status==="ativo"
                      ).map((co:any)=>(
                        <option key={co.id} value={co.id}>
                          {co.cliente_nome} · {co.plano_nome||"Personalizado"} · R$ {parseFloat(co.valor_mensal||0).toFixed(2).replace(".",",")}
                        </option>
                      ))}
                    </select>
                    <button type="button" className="btn btn-primary" style={{flexShrink:0}}
                      onClick={()=>{
                        const sel = document.getElementById("sel-contrato") as HTMLSelectElement
                        if (!sel.value) return
                        const co = contratos.find((c:any)=>c.id===sel.value)
                        if (!co) return
                        setAtivoContratos([...ativoContratos, {
                          contrato_id:co.id, cliente_nome:co.cliente_nome,
                          plano_nome:co.plano_nome, valor_mensal:co.valor_mensal,
                          principal:ativoContratos.length===0, novo:true
                        }])
                        sel.value=""
                      }}>
                      + Vincular
                    </button>
                  </div>
                )}
                {ativoContratos.length === 0 && (
                  <div style={{fontSize:12,color:"#475569",padding:"8px 0"}}>Nenhum contrato vinculado</div>
                )}
                {ativoContratos.map((ac:any,i:number)=>(
                  <div key={ac.contrato_id||i} style={{display:"flex",alignItems:"center",gap:8,
                    background:"#0d1b2e",borderRadius:8,padding:"8px 12px",marginBottom:6,
                    border:`1px solid ${ac.principal?"#22c55e":"#2d4166"}`}}>
                    <span style={{fontSize:16}}>📄</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:11,fontWeight:500}}>{ac.plano_nome||"Personalizado"}</div>
                      <div style={{fontSize:10,color:"#64748b"}}>{ac.cliente_nome} · R$ {parseFloat(ac.valor_mensal||0).toFixed(2).replace(".",",")}/mês</div>
                    </div>
                    {ac.principal
                      ? <span style={{fontSize:9,background:"#14532d",border:"1px solid #22c55e",borderRadius:8,padding:"1px 6px",color:"#4ade80"}}>Principal</span>
                      : <button type="button" onClick={()=>setAtivoContratos(ativoContratos.map((x:any,j:number)=>({...x,principal:j===i})))}
                          style={{fontSize:10,background:"none",border:"1px solid #2d4166",borderRadius:10,padding:"2px 8px",color:"#64748b",cursor:"pointer"}}>
                          Tornar principal
                        </button>
                    }
                    <button type="button" onClick={()=>setAtivoContratos(ativoContratos.filter((_:any,j:number)=>j!==i))}
                      style={{background:"#450a0a",border:"1px solid #dc2626",borderRadius:6,color:"#f87171",padding:"3px 7px",cursor:"pointer",fontSize:12}}>✕</button>
                  </div>
                ))}
              </div>

              <div className="form-group full">
                <label>Observações</label>
                <input value={form.observacoes} onChange={e=>setForm({...form,observacoes:e.target.value})} placeholder="Opcional" />
              </div>
              </div>
            </div>
            <div style={{background:"#0c2a4a",border:"1px solid #0ea5e9",borderRadius:8,padding:10,marginTop:12,fontSize:12,color:"#38bdf8"}}>
              ℹ️ Suntech e Teltonika atualizam o hodômetro automaticamente. Para GT06/J16 use o botão 📏 na listagem.
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end",marginTop:16}}>
              <button className="btn btn-ghost" onClick={()=>setModal(false)}>Cancelar</button>
              <button className="btn btn-primary" onClick={salvar}>💾 {editando?"Salvar alterações":"Cadastrar ativo"}</button>
            </div>
          </div>
        </div>
      )}
      {seletorIconeAberto && (
        <SeletorIconeAtivo
          iconIdAtual={form.icon_id}
          corAtual={form.icon_color}
          onConfirmar={({iconId, cor}) => {
            setForm({...form, icon_id: iconId, icon_color: cor})
            setSeletorIconeAberto(false)
          }}
          onFechar={() => setSeletorIconeAberto(false)}
        />
      )}

      {/* Modal hodômetro */}
      {modalKm && (
        <div className="modal-overlay" onClick={()=>setModalKm(null)}>
          <div className="modal" style={{width:400}} onClick={e=>e.stopPropagation()}>
            <div className="modal-header">
              <h3>📏 Atualizar hodômetro</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModalKm(null)}>✕</button>
            </div>
            <div style={{background:"#0d1b2e",borderRadius:8,padding:12,marginBottom:16}}>
              <div style={{fontWeight:700}}>{modalKm.nome}{modalKm.placa&&` · ${modalKm.placa}`}</div>
              <div style={{fontSize:12,color:"#64748b",marginTop:2}}>
                Atual: {parseFloat(modalKm.hodometro_atual||0).toLocaleString("pt-BR")} km
              </div>
            </div>
            <div className="form-group" style={{marginBottom:12}}>
              <label>Novo hodômetro (km) *</label>
              <input type="number" value={novoKm} onChange={e=>setNovoKm(e.target.value)}
                placeholder="Digite o km atual do veículo" min={0} autoFocus />
            </div>
            <div style={{background:"#451a03",border:"1px solid #f59e0b",borderRadius:8,padding:10,marginBottom:12,fontSize:11,color:"#fbbf24"}}>
              ⚠️ Use este campo para GT06/J16. Suntech e Teltonika atualizam automaticamente via rastreador.
            </div>
            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button className="btn btn-ghost" onClick={()=>setModalKm(null)}>Cancelar</button>
              <button className="btn btn-primary" onClick={atualizarKm}>✅ Atualizar</button>
            </div>
          </div>
        </div>
      )}
      {modalDesinstalar && ativoDesinstalar && (
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:2000,
          display:"flex",alignItems:"center",justifyContent:"center",padding:20}}>
          <div className="card" style={{width:"100%",maxWidth:540,maxHeight:"90vh",overflowY:"auto"}}>
            <div style={{display:"flex",justifyContent:"space-between",marginBottom:16}}>
              <h3 style={{color:"#f59e0b"}}>🔧 Registrar Desinstalação</h3>
              <button className="btn btn-ghost" style={{padding:"4px 8px"}} onClick={()=>setModalDesinstalar(false)}>✕</button>
            </div>

            {/* Info do ativo */}
            <div style={{background:"#451a03",border:"1px solid #f59e0b",borderRadius:8,padding:12,marginBottom:16}}>
              <div style={{fontWeight:600,fontSize:14}}>{ativoDesinstalar.nome}</div>
              {ativoDesinstalar.placa && <div style={{fontSize:11,color:"#94a3b8"}}>{ativoDesinstalar.placa} · {ativoDesinstalar.marca} {ativoDesinstalar.modelo_veiculo}</div>}
              {ativoDesinstalar.data_ativacao && <div style={{fontSize:11,color:"#f59e0b",marginTop:4}}>
                Instalado em: {new Date(ativoDesinstalar.data_ativacao).toLocaleDateString("pt-BR")}
              </div>}
            </div>

            {/* Seleção de rastreadores */}
            {ativoRastreadoresDesinst.length > 0 && (
              <div style={{marginBottom:16}}>
                <label style={{fontSize:12,fontWeight:600,color:"#94a3b8",display:"block",marginBottom:8}}>
                  📡 Selecione o(s) rastreador(es) a desinstalar
                </label>
                {ativoRastreadoresDesinst.map((r:any)=>(
                  <div key={r.rastreador_id||r.id}
                    onClick={()=>{
                      const id = r.rastreador_id||r.id
                      const sels = formDesinstalar.rastreadores_selecionados||[]
                      const jaTem = sels.find((x:any)=>x.id===id)
                      if (jaTem) {
                        setFormDesinstalar({...formDesinstalar, rastreadores_selecionados: sels.filter((x:any)=>x.id!==id)})
                      } else {
                        setFormDesinstalar({...formDesinstalar, rastreadores_selecionados: [...sels, {id, nome:r.nome||r.imei, imei:r.imei, custo:""}]})
                      }
                    }}
                    style={{display:"flex",alignItems:"center",gap:10,padding:"10px 12px",
                      marginBottom:6,borderRadius:8,cursor:"pointer",
                      border:`2px solid ${(formDesinstalar.rastreadores_selecionados||[]).find((x:any)=>x.id===(r.rastreador_id||r.id))?"#f59e0b":"#2d4166"}`,
                      background:(formDesinstalar.rastreadores_selecionados||[]).find((x:any)=>x.id===(r.rastreador_id||r.id))?"#451a03":"#0d1b2e"}}>
                    <span style={{fontSize:16}}>📡</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,fontWeight:500}}>{r.nome||r.imei}</div>
                      <div style={{fontSize:10,color:"#64748b",fontFamily:"monospace"}}>{r.imei}</div>
                      {r.principal && <span style={{fontSize:9,background:"#14532d",borderRadius:8,padding:"1px 5px",color:"#4ade80"}}>Principal</span>}
                    </div>
                    <div style={{fontSize:18}}>{(formDesinstalar.rastreadores_selecionados||[]).find((x:any)=>x.id===(r.rastreador_id||r.id))?"☑":"☐"}</div>
                  </div>
                ))}

                {/* Custo por rastreador selecionado */}
                {(formDesinstalar.rastreadores_selecionados||[]).map((rs:any,ri:number)=>(
                  <div key={rs.id} style={{display:"flex",alignItems:"center",gap:8,marginTop:6,
                    background:"#0c2a4a",borderRadius:8,padding:"8px 12px",border:"1px solid #2d4166"}}>
                    <span style={{fontSize:11,flex:1,color:"#94a3b8"}}>💰 Custo desinstalação — {rs.nome}</span>
                    <div style={{display:"flex",alignItems:"center",gap:4}}>
                      <span style={{fontSize:11,color:"#64748b"}}>R$</span>
                      <input type="number" value={rs.custo} step="0.01" min="0"
                        onChange={e=>{
                          const sels = [...(formDesinstalar.rastreadores_selecionados||[])]
                          sels[ri] = {...sels[ri], custo: e.target.value}
                          setFormDesinstalar({...formDesinstalar, rastreadores_selecionados: sels})
                        }}
                        placeholder="0,00"
                        style={{width:90,padding:"4px 6px",fontSize:12,textAlign:"right"}} />
                    </div>
                  </div>
                ))}
              </div>
            )}

            <div className="form-grid">
              <div className="form-group">
                <label>📅 Data de desinstalação *</label>
                <input type="date" value={formDesinstalar.data_desinstalacao}
                  max={new Date().toISOString().split("T")[0]}
                  onChange={e=>setFormDesinstalar({...formDesinstalar,data_desinstalacao:e.target.value})} />
                {formDesinstalar.data_desinstalacao && ativoDesinstalar.data_ativacao && (()=>{
                  const ini = new Date(ativoDesinstalar.data_ativacao)
                  const fim = new Date(formDesinstalar.data_desinstalacao)
                  const dias = Math.ceil((fim.getTime()-ini.getTime())/(1000*60*60*24))+1
                  const diasMes = new Date(fim.getFullYear(),fim.getMonth()+1,0).getDate()
                  return (
                    <div style={{fontSize:11,color:"#38bdf8",marginTop:3}}>
                      📅 {dias} dia(s) de uso · Pro rata: {dias}/{diasMes} do mês
                    </div>
                  )
                })()}
              </div>

              <div className="form-group">
                <label>Motivo</label>
                <select value={formDesinstalar.motivo}
                  onChange={e=>setFormDesinstalar({...formDesinstalar,motivo:e.target.value})}>
                  <option value="">— Selecione —</option>
                  <option>Fim de contrato</option>
                  <option>Cancelamento do cliente</option>
                  <option>Inadimplência</option>
                  <option>Venda do veículo</option>
                  <option>Troca de rastreador</option>
                  <option>Manutenção</option>
                  <option>Outro</option>
                </select>
              </div>

              <div className="form-group full">
                <label>
                  Observações {formDesinstalar.motivo==="Outro" && <span style={{color:"#f87171"}}>*</span>}
                </label>
                <input value={formDesinstalar.observacoes}
                  onChange={e=>setFormDesinstalar({...formDesinstalar,observacoes:e.target.value})}
                  placeholder={formDesinstalar.motivo==="Outro"?"Obrigatório — descreva o motivo...":"Detalhes adicionais..."}
                  style={{borderColor: formDesinstalar.motivo==="Outro" && !formDesinstalar.observacoes ? "#f59e0b" : undefined}} />
                {formDesinstalar.motivo==="Outro" && !formDesinstalar.observacoes && (
                  <div style={{fontSize:10,color:"#f59e0b",marginTop:3}}>⚠️ Campo obrigatório para o motivo "Outro"</div>
                )}
              </div>
            </div>

            {/* Resumo */}
            {formDesinstalar.data_desinstalacao && (()=>{
              const custosRastr = (formDesinstalar.rastreadores_selecionados||[]).reduce((s:number,r:any)=>s+parseFloat(r.custo||0),0)
              const totalCusto = custosRastr
              return totalCusto > 0 ? (
                <div style={{background:"#0c2a4a",border:"1px solid #0ea5e9",borderRadius:8,padding:12,marginBottom:12}}>
                  <div style={{fontSize:11,fontWeight:600,color:"#38bdf8",marginBottom:6}}>📊 Resumo da desinstalação</div>
                  {(formDesinstalar.rastreadores_selecionados||[]).map((r:any)=>r.custo>0&&(
                    <div key={r.id} style={{fontSize:11,color:"#94a3b8",display:"flex",justifyContent:"space-between"}}>
                      <span>🔧 {r.nome}</span>
                      <span>R$ {parseFloat(r.custo).toFixed(2).replace(".",",")}</span>
                    </div>
                  ))}
                  <div style={{borderTop:"1px solid #2d4166",marginTop:6,paddingTop:6,display:"flex",justifyContent:"space-between"}}>
                    <span style={{fontSize:12,fontWeight:600,color:"#f1f5f9"}}>Total desinstalação</span>
                    <span style={{fontSize:13,fontWeight:700,color:"#f59e0b"}}>R$ {totalCusto.toFixed(2).replace(".",",")}</span>
                  </div>
                </div>
              ) : null
            })()}

            <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
              <button className="btn btn-ghost" onClick={()=>setModalDesinstalar(false)}>Cancelar</button>
              <button onClick={desinstalar}
                style={{background:"#f59e0b",border:"none",borderRadius:8,color:"#000",padding:"8px 16px",
                  cursor:"pointer",fontWeight:600,fontFamily:"Inter",fontSize:13}}>
                🔧 Confirmar desinstalação
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}
